import type { QueryKey } from "../query/path-query-key";

/**
 * Cross-cutting query keys invalidated on every mutation.
 *
 * These timelines/streams aggregate data from ANY module, so a mutation
 * in (say) `car-rental` still needs to refresh the activity feed attached
 * to a CRM lead. Listed here as path-based keys following the canonical
 * full-segment scheme (see `pathToQueryKey`).
 *
 * To opt out for a specific mutation, pass `invalidateCrossCutting: false`
 * to `useApiMutation`.
 */
export const CROSS_CUTTING_QUERY_KEYS: readonly QueryKey[] = [
  ["core", "activities"],
  ["core", "comments"],
  ["core", "notes"],
  ["core", "tasks"],
  ["core", "events"],
  ["core", "followers"],
  ["core", "notifications"],
  ["core", "tags"],
  ["core", "versions"],
] as const;
